import { Card, Divider } from "antd";

import LoginForm from "./components/LoginForm";
import { styles } from "./styles/loginStyles";
import logo from "../../assets/images/airp_logo.png";
import dayjs from "../../config/dayjs";

export default function LoginPage() {
  return (
    <div style={styles.container}>
      <div style={{ width: "100%" }}>
        <div style={styles.logoContainer}>
          <img alt="logo" src={logo} style={styles.logo} />
        </div>
        <Card title="Login" style={styles.loginCard}>
          <LoginForm />
          <div style={styles.registerText}>
            Don't have an account? <a href="/register">Click here</a> to
            register as a new user.
          </div>
          <Divider />
          <div style={styles.copyright}>© AIRP {dayjs().year()}</div>
        </Card>
      </div>
    </div>
  );
}
